import React from 'react'
import { VerdictColorVariant, SignalVerdict } from '../types'
import SomeFromAll from './some-from-all'
import { getColorSchemaClass, getSignalVerdictIcon } from '../helpers'
import { useVerdictLabel } from '../hooks/use-verdict-label'

export function CategoryIcon({
  text,
  iconName,
  variant = SignalVerdict.Unknown,
  amount,
  className,
  onClick,
  showText = true,
}: {
  text?: string
  iconName?: string
  variant?: VerdictColorVariant
  amount: number | [number, number] | null
  className?: string
  onClick?: CallableFunction
  showText?: boolean
}) {
  const verdictLabel = useVerdictLabel(variant, { custom: { error: 'error', neutral: 'other' } })

  if (typeof iconName === 'undefined') {
    iconName = getSignalVerdictIcon(variant)
  }
  text = !showText ? '' : text ?? verdictLabel

  className = `category-icon d-flex flex-row align-items-center p-2 ${className ?? ''} ${
    onClick ? 'interactive cursor-pointer' : ''
  }`
  const iconClass = `ds3-icon ds3-${iconName} me-2 ${getColorSchemaClass(variant)} ${onClick ? '' : 'cursor-default'}`

  return (
    <div
      className={className}
      onClick={(e) => {
        e.preventDefault()
        onClick?.()
      }}
    >
      <i className={iconClass} />
      {text ? <div className="icon-text text-capital ellipsis">{text}</div> : null}
      <div className="flex-grow-1 text-end me-2">
        {Array.isArray(amount) ? <SomeFromAll amount={amount} /> : <span className="amount">{amount ?? '-'}</span>}
      </div>
    </div>
  )
}
